import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { spreadsheetInterface } from 'src/app/util/interfaces/spreadsheet';
import { environment } from 'src/environments/environment';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class ReportSpreadsheetService {
	private getSpreadsheetDataUrl = environment.baseApiUrl + 'leanmanagement/detail/{idIndicator}';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getSpreadsheetData(idIndicator: string): Observable<spreadsheetInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getSpreadsheetDataUrl = this.getSpreadsheetDataUrl.replace('{idIndicator}', idIndicator);
		return this.http.get<any>(getSpreadsheetDataUrl, { headers: headers }).pipe(
			map((spreadsheetData) => {
				spreadsheetData = spreadsheetData[0];
				const newSpreadsheet: spreadsheetInterface = {
					id: '',
					title: '',
					selectedItemAxis: [-1, -1],
					sort: { sort_column: 0, sort_down: true },
					hiddenLines: [],
					lines: [],
				};

				spreadsheetData.data.forEach((line: any) => {
					const newLine: spreadsheetInterface['lines'][number] = {
						generatedBlank: false,
						cells: [],
					};

					line.item.forEach((item: any) => {
						const newCell: spreadsheetInterface['lines'][number]['cells'][number] = {
							header_cell: { search_value: '' },
							item_name: item.name,
							item_value: item.value,
						};

						newLine.cells.push(newCell);
					});

					newSpreadsheet.lines.push(newLine);
				});

				return newSpreadsheet;
			})
		);
		const spreadsheetMock: spreadsheetInterface = {
			id: '',
			title: 'Spreadsheeet mock',
			selectedItemAxis: [-1, -1],
			sort: {
				sort_down: true,
				sort_column: 0,
			},
			lines: [
				{
					generatedBlank: false,
					cells: [
						{ item_name: 'ID', item_value: 'ID', header_cell: { search_value: '' } },
						{ item_name: 'Detalhamento', item_value: 'Detailment', header_cell: { search_value: '' } },
						{ item_name: 'Ativo', item_value: 'Active', header_cell: { search_value: '' } },
					],
				},
				{
					generatedBlank: false,
					cells: [
						{ item_name: '31856209', item_value: '31856209' },
						{ item_name: 'd1', item_value: 'd1' },
						{ item_name: 'Sim', item_value: 'true' },
					],
				},
				{
					generatedBlank: false,
					cells: [
						{ item_name: '31856210', item_value: '31856210' },
						{ item_name: 'd2', item_value: 'd2' },
						{ item_name: 'Sim', item_value: 'true' },
					],
				},
				{
					generatedBlank: false,
					cells: [
						{ item_name: '31856212', item_value: '31856212' },
						{ item_name: 'd4', item_value: 'd4' },
						{ item_name: 'Sim', item_value: 'true' },
					],
				},
				{
					generatedBlank: false,
					cells: [
						{ item_name: '31856211', item_value: '31856211' },
						{ item_name: 'd3', item_value: 'd3' },
						{ item_name: 'Não', item_value: 'false' },
					],
				},
			],
			hiddenLines: [],
		};

		return of(spreadsheetMock);
	}
}
